import { defineAsyncComponent } from 'vue'
export default {
  custom: defineAsyncComponent(() => import("/home/vsts/work/1/s/packages/admin-dashboard/layouts/custom.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/vsts/work/1/s/packages/admin-dashboard/layouts/default.vue").then(m => m.default || m))
}